export default __webpack_public_path__ + "static/media/carousel-2-min.e0173f82.png";